/**
 * English box-plot prompts and data titles (ADR 0099 §3).
 *
 * The prompts are the same for every context; the title above the plot says
 * what the data is, as a line plot's does. `from`, `to` and `step` are the
 * number line the plot is drawn over, every tick labelled, and are the same
 * numbers in all three languages.
 */
export const boxPlotPrompts = {
    median: () => `What is the median?`,
    lowerQuartile: () => `What is the lower quartile?`,
    upperQuartile: () => `What is the upper quartile?`,
    range: () => `What is the range?`,
    interquartileRange: () => `What is the interquartile range?`,
};

export const boxPlotContexts: { title: string; from: number; to: number; step: number }[] = [
    { title: 'Goals scored by each player this season', from: 0, to: 20, step: 1 },
    { title: 'Scores on a 20-point quiz', from: 0, to: 20, step: 1 },
    { title: 'Minutes each student takes to get to school', from: 0, to: 40, step: 2 },
    { title: 'Heights of sunflower seedlings (cm)', from: 0, to: 40, step: 2 },
    { title: 'Scores on a math test', from: 0, to: 100, step: 5 },
    { title: 'Ages of people at a party', from: 0, to: 100, step: 5 },
];
